import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=1a59ac88&scoped=true"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=1a59ac88&prod&lang=scss"
import style1 from "./Tasks.vue?vue&type=style&index=1&id=1a59ac88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a59ac88",
  null
  
)

export default component.exports